import { Controller } from '@hotwired/stimulus';

// Copie le payload intégral d'un événement de trace (fetch de l'export JSON,
// jamais un data-attribute : les payloads font des dizaines de Ko).
// Distinct de clipboard_controller (contrat text inline, autres appelants).
export default class extends Controller {
  static values = { url: String };

  async copy() {
    const response = await fetch(this.urlValue);
    await navigator.clipboard.writeText(await response.text());
  }
}
